import "./UkCitiesAreas.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Locations from "./sections/Locations";
import LocalBridge from "./sections/LocalBridge";
import Footer from "@/reusable_sections/Footer";
export default function UkCitiesAreasPage() {
  return <div>
      <Header />
      <Hero />
      <Locations />
      <LocalBridge />
      <Footer />
    </div>;
}